import { __awaiter, __generator } from "tslib";
import { getAdminConstructionApiUrl } from "@adsk/acs-sc-web-platform-api";
import fetcherWithRegionHeader from "../../utils/fetcherWithRegionHeader";
export var createProjectUser = function (props) { return __awaiter(void 0, void 0, void 0, function () {
    var createProjectUserRequestBody;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                createProjectUserRequestBody = {
                    email: props.userEmail,
                    roleIds: [],
                    products: props
                        .products.filter(function (product) {
                        return product.key !== "accountAdministration" &&
                            (product.status === "activating" || product.status === "active");
                    })
                        .map(function (product) { return ({ key: product.key, access: "administrator" }); }),
                };
                return [4 /*yield*/, fetcherWithRegionHeader("".concat(getAdminConstructionApiUrl(), "/v1/projects/").concat(props.projectId, "/users"), {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(createProjectUserRequestBody),
                    })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
